import React from "react";

import { Typography } from "@mui/material";
export default function BackendErrorMessage({ message }) {
  return <Typography sx={{ color: "red", marginTop: "20px", marginLeft: "20px" }}>{message}</Typography>;
}
